import { render } from "./quiz2d.svg?vue&type=template&id=06c6c1aa"
const script = {}
script.render = render

export default script